<template>
    <div class="container-fluid">
        <h3>Upload new resources:</h3>
        <form @submit.prevent="handleFormSubmit" v-if="this.edit == 0">
            <basic-input v-model="form.title" label="Title" name="title" />
            <basic-input v-model="form.description" label="Description" name="description" />
            <label>Type</label><br>
            <select v-model="form.resource_type_id" name="resource_type_id">
                <option :value="type.id" v-for="type in this.types">{{type.name}}</option>
            </select>
            <basic-input ref="uploadFile" label="Add Files" name="file" type="file" @change="handleTrackFile" />
            <basic-input v-model="form.is_active" label="Is Active" name="is_active" type="checkbox" />
            <button class="btn btn-primary" type="submit">Submit</button>
        </form>
        <form @submit.prevent="update" v-if="this.edit > 0">
            <basic-input v-model="formUpdate.title" label="Title" name="title" />
            <basic-input v-model="formUpdate.description" label="Description" name="description" />
            <label>Type</label><br>
            <select v-model="formUpdate.resource_type_id" name="resource_type_id">
                <option :value="type.id" v-for="type in this.types">{{type.name}}</option>
            </select>
            <basic-input v-model="formUpdate.is_active" label="Is Active" name="is_active" type="checkbox" />
            <button class="btn btn-primary" type="submit">Update</button>
        </form>
    </div>
</template>
<script>
import { get } from 'lodash';

export default {
    props: [''],
    name: 'ProductResource',
    data () {
        return {
            resources: [],
            types: {},
            edit: 0,
            form: {
                title: '',
                description: '',
                resource_type_id: 0,
                is_active: true,
                file: {},
            },
            formUpdate: {
                title: '',
                description: '',
                resource_type_id: 0,
                is_active: true,
            },
            sendingForm: null,
            sendingForm1: null,
        };
    },
    methods: {
        get (arr, key, defaultValue = '') {
            return get(arr, key, defaultValue);
        },
        handleTrackFile ({ target }) {
            const { files = null } = target;
            if (!files || files.length === 0) {
                return true;
            }

            this.sendingForm = new FormData();
            this.sendingForm1 = new FormData();
            this.sendingForm.append('file', files[0], files[0].name);
        },
        async handleFormSubmit () {
            const { title, description, is_active, resource_type_id } = this.form;
            this.sendingForm.append('title', title);
            this.sendingForm.append('description', description);
            this.sendingForm.append('is_active', is_active);
            this.sendingForm.append('resource_type_id', resource_type_id);
            this.sendingForm.append('edit', this.edit);

            try {
                // if(this.edit > 0){
                //     await axios.post(`/api/product/resource/put`,this.sendingForm);
                //     this.edit = 0;
                // }
                // else {
                //     await axios.post(`/api/product/${this.product_id}/resource`, this.sendingForm);
                // }
                await this.load();

                this.$refs.uploadFile.value = null;
                this.sendingForm = null;
                this.form = {
                    title: '',
                    resource_type_id: '',
                    is_active: true,
                    file: {},
                };
            } catch (e) {
                console.log('upload error', { e });
            }
        },
        // async update(){
        //
        //     const { title, description, is_active, resource_type_id } = this.formUpdate;
        //     // this.sendingForm.append('title', title);
        //     // this.sendingForm1.append('description', description);
        //     // this.sendingForm1.append('is_active', is_active);
        //     // this.sendingForm1.append('resource_type_id', resource_type_id);
        //     // this.sendingForm1.append('edit', this.edit);
        //     console.log(title);
        //     console.log(description);
        //     console.log(is_active);
        //     console.log(resource_type_id);
        //     try {
        //         await axios.post(`/api/product/resource/put`,this.formUpdate);
        //         alert(title + " is updated");
        //         this.edit = 0;
        //         this.load();
        //     } catch (e) {
        //         console.log('upload error', { e });
        //     }
        // },
        // async deleteResource ({ uuid }) {
        //     await axios.delete(`/api/product/${this.product_id}/resource/${uuid}`);
        //     await this.load();
        // },
        async loadResource(resource){
            this.formUpdate = Object.assign({}, resource);
            this.edit = resource.id;
        },
        // async load () {
        //     const { data } = await axios.get(`/api/product/${this.product_id}`);
        //     const { images = [], resources = [], ...product } = data || {};
        //
        //     this.resources = resources;
        // },
        async loadTypes () {
            const axios = require('axios').default;

            axios.get('/api/product/resourceTypes')
                .then(resp => {
                    this.types = resp.data;
                })
        },
    },
    async mounted () {
        // await this.load();
        await this.loadTypes();
    },
};
</script>
